var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button is-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }